import React, { createContext, useState, useEffect } from 'react';
import api from '../services/api';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    const savedUser = localStorage.getItem('user');
    return savedUser ? JSON.parse(savedUser) : null;
  });
  const [token, setToken] = useState(() => localStorage.getItem('token') || null);
  const [company, setCompany] = useState(null);
  const [firms, setFirms] = useState([]);
  const [selectedFirmId, setSelectedFirmId] = useState(() => {
    return user ? user.firmId : 0;
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchCompanyAndFirms();
  }, []);

  const fetchCompanyAndFirms = async () => {
    try {
      const [compRes, firmRes] = await Promise.all([
        api.get('/auth/company'),
        api.get('/auth/firms')
      ]);
      setCompany(compRes.data);
      setFirms(firmRes.data);
    } catch (err) {
      console.error('Failed to load company or firm details', err);
    }
  };

  const login = async (username, password) => {
    setLoading(true);
    try {
      const res = await api.post('/auth/login', { username, password });
      const { token: newToken, user: userData } = res.data;

      setToken(newToken);
      setUser(userData);
      setSelectedFirmId(userData.firmId || 0);

      localStorage.setItem('token', newToken);
      localStorage.setItem('user', JSON.stringify(userData));

      // Refresh firms list based on logged-in user permissions
      fetchCompanyAndFirms();

      return { success: true };
    } catch (err) {
      console.error('Login error', err);
      const errMsg = err.response?.data?.detail
        ? `${err.response.data.message} (${err.response.data.detail})`
        : (err.response?.data?.message || 'Login failed. Please check server and database connection.');
      return {
        success: false,
        message: errMsg
      };
    } finally {
      setLoading(false);
    }
  };

  const logout = () => {
    setToken(null);
    setUser(null);
    localStorage.removeItem('token');
    localStorage.removeItem('user');
  };

  return (
    <AuthContext.Provider
      value={{
        user,
        token,
        company,
        firms,
        selectedFirmId,
        setSelectedFirmId,
        loading,
        login,
        logout,
        isAuthenticated: !!token
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
